<template>
	<popup
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			:is-btn-safe="!customer_id"
			title="Trucks"
			is-all-height
	>
	<div class="formDialog truckForm" :class="{ 'onlyViewWrap': getPermissionAction }">
		<div class="formDialogHeader">
			<div class="formDialogHeader_card service" :class="{ 'onlyView': getPermissionAction }">
				<field
						margin="0"
						:class-error="$v.truck_number && $v.truck_number.$error"
						width="160px"
						label="Truck #"
						placeholder="Enter truck number"
						@updateInput="onInput($event, 'truck_number')"
						:setInputValue="truck_number"
						is-required
				></field>
				<field
						:class-error="$v.customer_id && $v.customer_id.$error"
						margin="0"
						width="170px"
						label="Customer"
						placeholder="Select customer"
						@updateAutocomplete="onAutocomplete($event, 'customer_id')"
						:autocompleteValue="customer_id"
						:items="customers"
						:isClearable="false"
						is-autocomplete
						is-required
				></field>
				<field
						:class-error="$v.date_from && $v.date_from.$error"
						margin="0"
						width="145px"
						type="text"
						label="Date from"
						placeholder="Enter date from"
						displayFormat="YYYY-MM-DD"
						format="YYYY-MM-DD"
						:dateValue="date_from"
						@updateTime="onDate($event, 'date_from')"
						:pickTime="false"
						is-time
						is-required
				></field>
				<button  @click="onChangeCompany(true)" type="button" :disabled="isChangeCompanyButton">
					<svg-sprite
							:style="`color: ${isChangeCompanyButton ? '#8F90A6' : '#19BC38'}`"
							icon-id="reset"
							height="20"
							width="20"
					></svg-sprite>
				</button>
				<field
						margin="0"
						width="170px"
						label="Trailer #"
						placeholder="Enter trailer"
						@updateAutocomplete="onAutocomplete($event, 'trailer_id')"
						@updateClearAutocomplete="onClearAutocomplete($event, 'trailer_id')"
						:autocompleteValue="trailer_id"
						:items="trailer"
						is-autocomplete
						:is-disabled="!customer_id"
				></field>
				<field
						margin="0"
						width="170px"
						label="Trailer type"
						placeholder=""
						:setInputValue="trailer_type"
						is-readonly
				></field>
				<div class="checkboxWrapper">
					<v-checkbox
							class="checkbox"
							:input-value="company_owner"
							label="Company owned"
							color="success"
							hide-details
							:disabled="getPermissionAction"
							@change="onCheckbox($event, 'company_owner')"
					></v-checkbox>
					<v-checkbox
							class="checkbox"
							:input-value="left_company"
							label="Left the company"
							color="success"
							hide-details
							:disabled="getPermissionAction"

							@change="onCheckbox($event, 'left_company')"
					></v-checkbox>
					<v-checkbox
							class="checkbox"
							:input-value="active"
							label="Active"
							color="success"
							hide-details
							:disabled="getPermissionAction"
							@change="onCheckbox($event, 'active')"
					></v-checkbox>
					<v-checkbox
							class="checkbox"
							:input-value="sold"
							label="Sold"
							color="success"
							hide-details
							:disabled="getPermissionAction"
							@change="onCheckbox($event, 'sold')"
					></v-checkbox>
				</div>
				<div class="groupField_wrap">
					<div :style="'background:' + getIndicatorColor" v-if="status_id" class="indicator"></div>
					<field
							margin="0 10px 0 auto"
							width="200px"
							label="Status"
							placeholder="Select status"
							@updateSelect="onAutocomplete($event, 'status_id')"
							:autocompleteValue="status_id"
							:items="statusList"
							:isClearable="false"
							is-select
					></field>
				</div>
			</div>
		</div>
		<div class="tabBlock">

				<tab-block
						:tab="tab"
						:tab-list="getTabList"
						@updateTab="onTab"
				></tab-block>

				<v-tabs-items v-model="tab" class="tabs-items">
					<v-tab-item>
						<first-tab
								:vin_code="vin_code"
								:plate="plate"
								:eld_name="eld_name"
								:eld="!!eld"
								:driver_id="driver_id"
								:team="!!team"
								:driver_second_id="driver_second_id"
								:model="model"
								:drivers="drivers"
								:customerId="!!customer_id"
								:isCreate="!id"
								:valid="$v"
								:services="services"
								:getPermissionAction="getPermissionAction"
								@updateFirstTab="onFirstTab"
						></first-tab>
					</v-tab-item>
					<v-tab-item>
						<second-tab :truckId="id" :isPage="isPage"></second-tab>
					</v-tab-item>
					<v-tab-item>
						<thirdTab
								:truck-id="id"
								:drivers="drivers"
								:equipments="equipments"
								:getPermissionAction="getPermissionAction"
								@updateEquipmentsSelectList="onEquipmentsSelectList"
						></thirdTab>
					</v-tab-item>
					<v-tab-item>
						<truck-value-tab
								:truckNumber="truck_number"
								:truckId="id"
								:hours="hours"
								:getPermissionAction="getPermissionAction"
								@updateValueTab="onUpdateValueTab"
						></truck-value-tab>
					</v-tab-item>
					<v-tab-item>
						<fourth-tab :getPermissionAction="getPermissionAction" :truck-id="id"></fourth-tab>
					</v-tab-item>
				</v-tabs-items>
		</div>

		<change-company
				v-if="isChangeCompany"
				:items="change_company"
				:customers="customers"
				@updateSettingsClose="onChangeCompany(false)"
				@updateSettingsCancel="onChangeCompany(false)"
				@updateEditServices="onEditServices"
		></change-company>
		
	</div>
	</popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import FirstTab from "@/components/Maintenance/Trucks/TruckForm/FirstTab/FirstTab";
// shared
import Popup from "@/shared/Popup/Popup";
// import TabBlock from "@/shared/TabBlock/TabBlock";
// async components
const SecondTab = () => import("@/components/Maintenance/Trucks/TruckForm/SecondTab/SecondTab");
const ThirdTab = () => import("@/components/Maintenance/Trucks/TruckForm/ThirdTab/ThirdTab");
const FourthTab = () => import("@/components/Maintenance/Trucks/TruckForm/FourthTab/FourthTab");
const TruckValueTab = () => import("@/components/Maintenance/Trucks/TruckForm/TruckValueTab/TruckValueTab");

// validate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// helpers
import getDefaultDate from "@/helper/getDefaultDate";
import { PERMISSIONS, STATUS_TRUCK_COLOR } from "@/constants/constants";
import TabBlock from "@/shared/TabBlock/TabBlock.vue";
import ChangeCompany from "@/shared/ChangeCompany/ChangeCompany.vue";

export default {
	name: "TruckForm",
	mixins: [ validationMixin ],
	components: {
		ChangeCompany,
		TabBlock,
		FirstTab,
		// TabBlock,
		Popup,
		SecondTab,
		ThirdTab,
		FourthTab,
		TruckValueTab,
	},
	props: {
		typeForm: String,
		permissions: Object,
		item: Object,
		id: Number,
		isPage: Boolean
	},
	computed: {
		...mapGetters([ 'trucksItem' ]),
		getIndicatorColor() {
			const id = this.status_id?.id ?? this.status_id;
			return STATUS_TRUCK_COLOR[id];
		},
		isChangeCompanyButton() {
			return this.id && this.getPermissionAction;
		},
		getPermissionAction() {
			if ((this.permissions[PERMISSIONS.CREATE] && !this.id) || this.permissions[PERMISSIONS.EDIT]) return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
		getTabList() {
			const {
				truck_number,
				date_from,
				customer_id
			} = this.$v;

			const values = [
				{
					text: 'General info',
					error: truck_number.$error || date_from.$error || customer_id.$error
				}
			];

			if (!this.id) {
				return values;
			}

			return [ ...values,
				{
					text: 'Repairs',
					error: false
				},
				{
					text: 'Equipment',
					error: false
				},
				{
					text: 'Truck value',
					error: false
				},
				{
					text: 'Notes',
					error: false
				} ];
		}
	},
	data: () => ({
		hours: null,
		status_id: null,
		tab: null,
		truck_number: '',
		customer_id: null,
		trailer_id: null,
		date_from: getDefaultDate(),
		company_owner: true,
		active: true,
		left_company: false,
		sold: false,
		vin_code: null,
		plate: null,
		eld_name: null,
		model: null,
		eld: false,
		driver_id: null,
		driver_second_id: null,
		trailer_type: null,
		team: false,
		isChangeCompany: false,
		truck_equipment: [],
		statusList: [],
		customers: [],
		drivers: [],
		equipments: [],
		trailer: [],
		services: {},
		change_company: []
	}),
	validations() {
		return {
			truck_number: { required },
			date_from: { required },
			customer_id: { required },
			eld_name: this.eld ? { required } : {},
			driver_id: this.status_id === 1 ? { required } : {}
		};
	},
	methods: {
		...mapActions([ 'onTrucksCreate', 'onTrucksEdit', 'setAlert', 'onTrucksSave', 'onTrucksHistory', 'actionPreloader' ]),
		onCloseDialog(isRefresh) {
			this.$emit('updateCloseDialog', isRefresh);
		},
		onUpdateValueTab({ value, key }) {
			this[key] = value?.id ?? value;
		},
		async onTab(value) {
			this.tab = value;
		},
		onChangeCompany(value) {
			this.isChangeCompany = value;
		},
		onEditServices(obj) {
			const index = this.change_company.findIndex(item => item.id === obj.id);
			this.change_company.splice(index, 1, obj);
		},
		onFirstTab({ value, key }) {
			this[key] = value?.id ?? value;
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onClearAutocomplete({ value }, key) {
			this[key] = value;
		},
		async onAutocomplete({ value }, key) {
			if (!value) return false;
			this[key] = value?.id ?? value;

			if (key === 'customer_id') {
				const id = value?.id;
				this.trailer_id = null;
				this.driver_id = null;

				if (id) {
					const data = await this.onTrucksCreate(id);

					if (data) {
						const { customers, drivers, trailer } = data;
						this.customers = customers;
						this.drivers = drivers;
						this.trailer = trailer;
					}
				}
				this.actionPreloader(false);
			}

			if (key === 'trailer_id') {
				this.trailer_type = value['trailer_type'];
			}
		},
		onEquipmentsSelectList(values) {
			this.equipments = values;
		},
		onDate(date, key) {
			this[key] = date;
		},
		onCheckbox(value, key) {
			this[key] = value;
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.loading = true;

				const {
					truck_number,
					customer_id,
					trailer_id,
					date_from,
					company_owner,
					active,
					left_company,
					sold,
					vin_code,
					plate,
					eld_name,
					eld,
					model,
					driver_id,
					status_id,
					driver_second_id,
					trailer_type,
					team,
					change_company,
					truck_equipment,
					hours
				} = this.$data;

				const history = change_company ?? [].map(item => {
					const { truckId, truck_id, customer_id, from, to } = item;
					return { truckId, truck_id, customer_id, from, to };
				});

				const values = {
					truck_number,
					customer_id,
					trailer_id,
					date_from,
					company_owner: Number(company_owner),
					active: Number(active),
					left_company: Number(left_company),
					sold: Number(sold),
					vin_code,
					plate,
					eld_name,
					eld: Number(eld),
					model,
					driver_id,
					status_id,
					driver_second_id,
					trailer_type,
					team: Number(team),
					hours,
					truck_equipment
				};

				const { error } = await this.onTrucksSave({ values, truckId: this.id, type: this.typeForm, isPage: this.isPage });
				if (history.length) await this.onTrucksHistory(history);

				if (!error) {
					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onCloseDialog(1);
				} else {
					const { truck_number, vin_code, customer_id, driver_id, driver_second_id } = error;
					const vinError = truck_number || vin_code || customer_id || driver_id || driver_second_id;
					this.setAlert({ type: "error", message: vinError ? vinError[0] : "Saving error" });
				}

				this.loading = false;
			} else if (this.$v.driver_id.$error) {
				this.setAlert({ type: "error", message: "Error. There is no selected driver" });
			}
		}
	},
	async mounted() {
		if (this.id) {
			await this.onTrucksEdit(this.id);
		} else {
			await this.onTrucksCreate(null);
		}

		const {
			customers,
			drivers,
			trailer,
			change_company,
			truck_equipment,
			truck,
			services,
			equipments,
			status
		} = this.trucksItem;

		this.customers = customers;
		this.drivers = drivers;
		this.trailer = trailer;
		this.truck_equipment = truck_equipment;
		this.change_company = change_company;
		this.services = services;
		this.equipments = equipments;
		this.statusList = status;
		this.hours = truck?.hours;

		if (truck) {
			for (const truckKey in truck) {
				this[truckKey] = truck[truckKey];
			}
		}
	}
};
</script>

<style lang="scss">
.checkboxWrapper {
	.v-label {
		font-size: 14px;
		line-height: 20px;
	}
}
</style>
<style scoped lang="scss">
//@import "truckForm";
@import "@/assets/style/components/formDialog.scss";
</style>
